import { useState, useMemo, useEffect, useRef } from "react";
import axios from 'axios';
import config from '../config/config';
import { useNavigate } from 'react-router-dom';

const SAMPLE_TRANSACTIONz = [
  { id: "TXN-2024-001", date: "2024-03-01", student: "Emma Johnson", studentId: "STU-1021", grade: "10A", description: "Tuition Fee - Term 2", amount: 1250.00, type: "Tuition", status: "paid", createdBy: "admin@school.edu", paymentMethod: "Bank Transfer", reference: "REF-88821" },
  { id: "TXN-2024-002", date: "2024-03-03", student: "Liam Carter", studentId: "STU-1034", grade: "8B", description: "Sports Equipment Levy", amount: 85.50, type: "Levy", status: "paid", createdBy: "finance@school.edu", paymentMethod: "Cash", reference: "REF-88822" },
  { id: "TXN-2024-003", date: "2024-03-05", student: "Sophia Lee", studentId: "STU-1047", grade: "11C", description: "Library Fine", amount: 12.00, type: "Fine", status: "paid", createdBy: "admin@school.edu", paymentMethod: "Card", reference: "REF-88823" },
  { id: "TXN-2024-004", date: "2024-03-06", student: "Noah Williams", studentId: "STU-1058", grade: "9A", description: "Excursion - Science Museum", amount: 45.00, type: "Excursion", status: "paid", createdBy: "finance@school.edu", paymentMethod: "Online Portal", reference: "REF-88824" },
  { id: "TXN-2024-005", date: "2024-03-07", student: "Ava Thompson", studentId: "STU-1063", grade: "12B", description: "Canteen Account Top-up", amount: 30.00, type: "Canteen", status: "paid", createdBy: "admin@school.edu", paymentMethod: "Cash", reference: "REF-88825" },
  { id: "TXN-2024-006", date: "2024-03-08", student: "Oliver Martinez", studentId: "STU-1072", grade: "7D", description: "Uniform Purchase", amount: 220.00, type: "Uniform", status: "voided", createdBy: "admin@school.edu", paymentMethod: "Card", reference: "REF-88826", voidReason: "Duplicate entry", voidedBy: "principal@school.edu", voidedAt: "2024-03-08 14:22", voidCategory: "Duplicate Transaction", approvedBy: "bursar@school.edu" },
  { id: "TXN-2024-007", date: "2024-03-08", student: "Isabella Brown", studentId: "STU-1081", grade: "10A", description: "Tuition Fee - Term 2", amount: 1250.00, type: "Tuition", status: "paid", createdBy: "finance@school.edu", paymentMethod: "Bank Transfer", reference: "REF-88827" },
  { id: "TXN-2024-008", date: "2024-03-09", student: "James Wilson", studentId: "STU-1092", grade: "8C", description: "Music Tuition - Piano", amount: 160.00, type: "Tuition", status: "paid", createdBy: "admin@school.edu", paymentMethod: "Online Portal", reference: "REF-88828" },
  { id: "TXN-2024-009", date: "2024-03-09", student: "Mia Davis", studentId: "STU-1101", grade: "6A", description: "School Camp Deposit", amount: 95.00, type: "Excursion", status: "pending_void", createdBy: "finance@school.edu", paymentMethod: "Cash", reference: "REF-88829", voidReason: "Awaiting approval", voidedBy: "admin@school.edu", voidedAt: "2024-03-09 09:15", voidCategory: "Refund Request", approvedBy: null },
  { id: "TXN-2024-010", date: "2024-03-10", student: "Ethan Garcia", studentId: "STU-1114", grade: "11A", description: "Lab Fee - Chemistry", amount: 55.00, type: "Levy", status: "paid", createdBy: "admin@school.edu", paymentMethod: "Card", reference: "REF-88830" },
];

const VOID_CATEGORIES = [
  "Duplicate Transaction",
  "Incorrect Amount",
  "Wrong Student",
  "Payment Reversal",
  "Refund Request",
  "Data Entry Error",
  "Authorisation Error",
  "Other",
];

const TYPE_STYLES = {
  Mpesa:   { bg: "#eff6ff", color: "#2563eb", border: "#bfdbfe" },
  Bank:      { bg: "#f5f3ff", color: "#7c3aed", border: "#ddd6fe" },
  Excess:      { bg: "#fff1f2", color: "#e11d48", border: "#fecdd3" },
  Excursion: { bg: "#fffbeb", color: "#d97706", border: "#fde68a" },
  Canteen:   { bg: "#f0fdf4", color: "#16a34a", border: "#bbf7d0" },
  Uniform:   { bg: "#fdf4ff", color: "#a21caf", border: "#f0abfc" },
};

const STATUS_STYLES = {
  paid:         { bg: "#f0fdf4", color: "#15803d", border: "#bbf7d0", label: "Paid" },
  voided:       { bg: "#fff1f2", color: "#be123c", border: "#fecdd3", label: "Voided" },
  pending_void: { bg: "#fffbeb", color: "#b45309", border: "#fde68a", label: "Pending Void" },
};

function Badge({ style, children }) {
  return (
    <span style={{
      display: "inline-block", fontSize: "11px", fontWeight: 600,
      padding: "3px 9px", borderRadius: "20px", letterSpacing: "0.3px",
      background: style.bg, color: style.color, border: `1px solid ${style.border}`,
    }}>{children}</span>
  );
}

function StatCard({ label, value, sub, accent }) {
  return (
    <div style={{
      background: "#fff", border: "1px solid #e5e7eb", borderRadius: "14px",
      padding: "20px 24px", flex: 1, minWidth: "160px",
      borderTop: `3px solid ${accent}`,
    }}>
      <div style={{ fontSize: "12px", color: "#9ca3af", fontWeight: 600, letterSpacing: "0.5px", marginBottom: "6px" }}>{label}</div>
      <div style={{ fontSize: "24px", fontWeight: 700, color: "#111827" }}>{value}</div>
      {sub && <div style={{ fontSize: "12px", color: "#6b7280", marginTop: "4px" }}>{sub}</div>}
    </div>
  );
}

export default function App() {
  const token = localStorage.getItem('token');
  const detailRef = useRef(null);
  const navigate = useNavigate();
  const [SAMPLE_TRANSACTIONS, setData] = useState([]); // Note: SAMPLE_TRANSACTIONS not used, consider removing if not needed
  const [txns, setTxns] = useState(SAMPLE_TRANSACTIONz); // Initialized with sample, but will be overwritten by API
  const [searchText, setSearchText] = useState(''); // Unified search state
  const [filterStatus, setFilterStatus] = useState("all");
  const [filterType, setFilterType] = useState("all");
  const [sortField, setSortField] = useState("date");
  const [sortDir, setSortDir] = useState("desc");
  const [selected, setSelected] = useState(null);
  const [page, setPage] = useState(1); // Changed to 1-based paging assuming Laravel API uses 1 as first page
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [modal, setModal] = useState(null); // 'void' | 'audit' | 'reverse'
  const [form, setForm] = useState({ category: "", reason: "", approver: "", notify: true, confirm: "" });
  const [auditLog, setAuditLog] = useState([]);
  const [toast, setToast] = useState(null);
  const [activeTab, setActiveTab] = useState("transactions"); // 'transactions' | 'audit'

  const showToast = (msg, type = "success") => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 4000);
  };

  const handleSort = (field) => {
    if (sortField === field) setSortDir(d => d === "asc" ? "desc" : "asc");
    else { setSortField(field); setSortDir("asc"); }
  };


  const fetchStudents = async (pageNum = 1, perPage = rowsPerPage, searchQuery = filterStatus) => {
    try {
      setTxns([]);  
      await axios.get(config.API_URL + "/sanctum/csrf-cookie", { withCredentials: true });

      const xsrf = document.cookie.split('; ').find(r => r.startsWith('XSRF-TOKEN='))?.split('=')[1];

      const res = await axios.get(`${config.API_URL}/api/pulltransactions/${pageNum}/${perPage}/${searchQuery}`, {
        headers: {
          "Content-Type": "application/json",
          "X-XSRF-TOKEN": decodeURIComponent(xsrf || ''),
        },
        withCredentials: true,
      });

      setTxns(res.data.data);
      setAuditLog(res.data.audit_logs || []);
      // console.log(res.data.data);
      // setTotal(res.data.total); // Uncomment if you have a total state for pagination controls
    } catch (err) {
      console.error('Error fetching invoices:', err);
    }
  };

  useEffect(() => {
   
      fetchStudents(1, rowsPerPage, searchText.trim());
  

  }, [rowsPerPage,filterStatus]);

  const searchActual=()=>{
     setTxns([]); 
    fetchStudents(1,rowsPerPage,searchText);
  }

   const formatCurrency = (amount, currency = 'USD') => {
  return new Intl.NumberFormat('en-KE', {
    style: 'currency',
    currency: 'KES',
    minimumFractionDigits: 2
  }).format(amount);
};

  const filtered = useMemo(() => {
    let rows = [...txns];
    if (filterStatus !== "all") rows = rows.filter(t => t.status === filterStatus);
    // if (filterType !== "all") rows = rows.filter(t => t.type === filterType); // Commented as type filter might be server-side

    rows.sort((a, b) => {
      let av = a[sortField], bv = b[sortField];
      if (typeof av === "string") { av = av.toLowerCase(); bv = bv.toLowerCase(); }
      return sortDir === "asc" ? (av > bv ? 1 : -1) : (av < bv ? 1 : -1);
    });

    return rows;
  }, [txns, filterStatus, filterType, sortField, sortDir]);

  const stats = useMemo(() => ({
    totalPaid: txns.filter(t => t.status === "Paid").reduce((s, t) => s + t.amount, 0),
    totalVoided: txns.filter(t => t.status === "voided").reduce((s, t) => s + t.amount, 0),
    pendingVoid: txns.filter(t => t.status === "pending_void").length,
    voidCount: txns.filter(t => t.status === "voided").length,
  }), [txns]);

  const openVoid = () => { setForm({ category: "", reason: "", approver: "", notify: true, confirm: "" }); setModal("void"); };
  const openReverse = () => { setForm({ category: "", reason: "", approver: "", notify: true, confirm: "" }); setModal("reverse"); };



 const saveVoid = async (isApproved,payload) => {
    if (!token) {
      alert("Please log in to save");
      return;
    }

    try {
     
      await axios.get(config.API_URL + "/sanctum/csrf-cookie", { withCredentials: true });

      const xsrfToken = document.cookie
        .split('; ')
        .find(row => row.startsWith('XSRF-TOKEN='))
        ?.split('=')[1];

   

      const response = await axios.post(
        config.API_URL + "/api/saveVoid",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "X-XSRF-TOKEN": decodeURIComponent(xsrfToken || ''),
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        }
      );

      if (response.data.status === 1) {
       showToast(isApproved ? `${selected.id} voided successfully.` : `Void request for ${selected.id} submitted for approval.`);
    setModal(null); setSelected(null);
      } else {
        alert("Save failed: " + (response.data.message || "Unknown error"));
      }
    } catch (error) {
      console.error("Save error:", error);
      alert("Failed to save void request");
    } finally {
      //setSaving(false);
    }
  };

   const saveReverse = async (payload) => {
    if (!token) {
      alert("Please log in to save");
      return;
    }

    try {
     
      await axios.get(config.API_URL + "/sanctum/csrf-cookie", { withCredentials: true });

      const xsrfToken = document.cookie
        .split('; ')
        .find(row => row.startsWith('XSRF-TOKEN='))
        ?.split('=')[1];

   

      const response = await axios.post(
        config.API_URL + "/api/saveReverse",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "X-XSRF-TOKEN": decodeURIComponent(xsrfToken || ''),
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        }
      );

      if (response.data.status === 1) {
            showToast(`Void on ${selected.id} has been reversed.`, "info");
       //showToast(isApproved ? `${selected.id} reversed successfully.` : `Void request for ${selected.id} submitted for reversal.`);
    setModal(null); setSelected(null);
      } else {
        alert("Save failed: " + (response.data.message || "Unknown error"));
      }
    } catch (error) {
      console.error("Save error:", error);
      alert("Failed to save void request");
    } finally {
      //setSaving(false);
    }
  };

 const saveVoidApproval = async (payload) => {
    if (!token) {
      alert("Please log in to save");
      return;
    }

    try {
     
      await axios.get(config.API_URL + "/sanctum/csrf-cookie", { withCredentials: true });

      const xsrfToken = document.cookie
        .split('; ')
        .find(row => row.startsWith('XSRF-TOKEN='))
        ?.split('=')[1];

   

      const response = await axios.post(
        config.API_URL + "/api/saveVoidApproval",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "X-XSRF-TOKEN": decodeURIComponent(xsrfToken || ''),
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        }
      );

      if (response.data.status === 1) {
           showToast(`Void approved.`);
       //showToast(isApproved ? `${selected.id} reversed successfully.` : `Void request for ${selected.id} submitted for reversal.`);
    setModal(null); setSelected(null);
      } else {
        alert("Save failed: " + (response.data.message || "Unknown error"));
      }
    } catch (error) {
      console.error("Save error:", error);
      alert("Failed to save void request");
    } finally {
      //setSaving(false);
    }
  };


  const submitVoid = () => {
    const now = new Date().toISOString().slice(0, 16).replace("T", " ");
    const isApproved = !!form.approver.trim();
    const newStatus = isApproved ? "voided" : "pending_void";
    setTxns(prev => prev.map(t => t.id === selected.id ? {
      ...t, status: newStatus,
      voidCategory: form.category, voidReason: form.reason,
      voidedBy: "current.user@school.edu", voidedAt: now,
      approvedBy: isApproved ? form.approver : null,
    } : t));
    const payload={
      voidCategory: form.category, voidReason: form.reason,
      voidedBy: "current.user@school.edu", voidedAt: now,
      approvedBy: isApproved ? form.approver : null,
      selectedId:selected.id
    }
    saveVoid(isApproved,payload);
    fetchStudents(1,rowsPerPage,'');
   
  };

  const submitReverse = () => {
    const now = new Date().toISOString().slice(0, 16).replace("T", " ");
    setTxns(prev => prev.map(t => t.id === selected.id ? {
      ...t, status: "paid",
      voidCategory: undefined, voidReason: form.reason,
      voidedBy: undefined, voidedAt: undefined, approvedBy: undefined,
    } : t));
    const payload={
       voidReason: form.reason,
       voidCategory: 'Void reversed',
        selectedId:selected.id
    }
    saveReverse(payload);
   fetchStudents(1,rowsPerPage,'');
    showToast(`Void on ${selected.id} has been reversed.`, "info");
    setModal(null); setSelected(null);
  };

const approveVoid = async (txn) => {
  // First confirmation (simple)
  if (!window.confirm(`Approve void for transaction (${txn.student})?`)) {
    showToast("Action cancelled", "info");
    return;
  }

  // Optional: ask for approval note/reason (recommended for audit)
  const approvalNote = window.prompt(
    "Optional: Enter approval note or reason (Please note once this approved this action is irreversible):",
    "Void approved after review"
  ) || "Void approved";

  try {
    const now = new Date().toISOString().slice(0, 16).replace("T", " ");

    const payload = {
      id: txn.id,
      action: 'Void Approved',
      note: approvalNote.trim() || "Void approved"
    };

    saveVoidApproval(payload); // assume this returns Promise

   


  } catch (err) {
    showToast("Failed to approve void: " + (err.message || "Server error"), "error");
  }
};

  const canVoid = selected && selected.status === "Paid";
  const canReverse = selected && (selected.status === "pending_void");
  const canApprove = selected && selected.status === "pending_void";
  const formValid = form.category && form.reason.trim().length >= 10 && form.confirm === "VOID";

  const SortIcon = ({ field }) => {
    if (sortField !== field) return <span style={{ color: "#d1d5db", marginLeft: 4 }}>⇅</span>;
    return <span style={{ color: "#2563eb", marginLeft: 4 }}>{sortDir === "asc" ? "↑" : "↓"}</span>;
  };

  return (
    <div style={{ minHeight: "100vh", background: "#f8fafc", fontFamilyu: "'Quicksand', sans-serif", color: "#111827" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@400;500;600;700&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        ::-webkit-scrollbar { width: 5px; height: 5px; }
        ::-webkit-scrollbar-track { background: #f1f5f9; }
        ::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 10px; }
        .row-hover:hover { background: #f0f7ff !important; cursor: pointer; }
        .row-selected { background: #eff6ff !important; outline: 1px solid #bfdbfe; }
        .btn { font-family: 'Quicksand', sans-serif; font-weight: 600; cursor: pointer; border-radius: 8px; border: none; transition: all 0.15s; font-size: 13px; padding: 9px 18px; }
        .btn:hover { filter: brightness(0.94); transform: translateY(-1px); }
        .btn:active { transform: translateY(0); }
        .btn:disabled { opacity: 0.4; cursor: not-allowed; filter: none; transform: none; }
        .btn-danger { background: #fee2e2; color: #dc2626; border: 1px solid #fca5a5; }
        .btn-primary { background: #2563eb; color: #fff; }
        .btn-ghost { background: #f3f4f6; color: #374151; border: 1px solid #e5e7eb; }
        .btn-warning { background: #fef3c7; color: #d97706; border: 1px solid #fde68a; }
        .btn-success { background: #dcfce7; color: #15803d; border: 1px solid #86efac; }
        .tab { font-family: 'Quicksand', sans-serif; font-weight: 600; cursor: pointer; background: none; border: none; padding: 10px 20px; font-size: 14px; color: #6b7280; border-bottom: 2px solid transparent; transition: all 0.15s; }
        .tab.active { color: #2563eb; border-bottom-color: #2563eb; }
        .tab:hover { color: #1d4ed8; }
        .th-btn { background: none; border: none; cursor: pointer; font-family: 'Quicksand', sans-serif; font-weight: 700; font-size: 11px; color: #6b7280; letter-spacing: 0.5px; text-transform: uppercase; padding: 0; white-space: nowrap; }
        .th-btn:hover { color: #2563eb; }
        input, textarea, select { font-family: 'Quicksand', sans-serif; }
        .input-base { width: 100%; background: #fff; border: 1.5px solid #e5e7eb; border-radius: 8px; padding: 9px 13px; font-size: 13px; font-family: 'Quicksand', sans-serif; color: #111827; transition: border-color 0.15s, box-shadow 0.15s; outline: none; }
        .input-base:focus { border-color: #2563eb; box-shadow: 0 0 0 3px #eff6ff; }
        .modal-overlay { position: fixed; inset: 0; background: rgba(15,23,42,0.35); display: flex; align-items: center; justify-content: center; z-index: 100; backdrop-filter: blur(2px); animation: fadeIn 0.15s; }
        .modal-box { background: #fff; border-radius: 16px; padding: 32px; width: 100%; max-width: 520px; margin: 16px; box-shadow: 0 20px 60px rgba(0,0,0,0.15); animation: slideUp 0.2s ease; }
        @keyframes fadeIn { from { opacity: 0 } to { opacity: 1 } }
        @keyframes slideUp { from { opacity: 0; transform: translateY(16px) } to { opacity: 1; transform: translateY(0) } }
        .toast-wrap { position: fixed; bottom: 28px; right: 28px; z-index: 200; animation: slideToast 0.3s ease; }
        @keyframes slideToast { from { opacity: 0; transform: translateX(60px) } to { opacity: 1; transform: translateX(0) } }
        .detail-row { display: flex; gap: 8px; margin-bottom: 8px; font-size: 13px; }
        .detail-label { color: #9ca3af; min-width: 110px; font-weight: 600; }
        .detail-val { color: #374151; font-weight: 500; }
      `}</style>

      <div style={{ maxWidth: 1300, margin: "0 auto", padding: "28px 32px" }}>
        <div style={{ marginBottom: 24 }}>
          <h1 style={{ fontSize: 26, fontWeight: 700, color: "#111827" }}>Payment Transactions Management</h1>
          <p style={{ fontSize: 13, color: "#6b7280", marginTop: 4, fontWeight: 500 }}>Review, void, approve and audit financial transactions. All actions are logged for compliance.</p>
        </div>

        <div style={{ display: "flex", gap: 16, marginBottom: 28, flexWrap: "wrap" }}>
          <StatCard label="TOTAL COLLECTED" value={`${stats.totalPaid.toLocaleString("en-KE", { minimumFractionDigits: 2 })}`} sub={`${txns.filter(t => t.status === "Paid").length} recent transactions`} accent="#2563eb" />
          <StatCard label="TOTAL VOIDED" value={`${stats.totalVoided.toLocaleString("en-KE", { minimumFractionDigits: 2 })}`} sub={`${stats.voidCount} recent transactions`} accent="#dc2626" />
          <StatCard label="PENDING VOID" value={stats.pendingVoid} sub="Awaiting approval" accent="#d97706" />
          <StatCard label="VOID RATE" value={`${txns.length ? ((stats.voidCount / txns.length) * 100).toFixed(1) : 0}%`} sub="Of all recent transactions" accent="#7c3aed" />
        </div>

        <div style={{ borderBottom: "2px solid #e5e7eb", marginBottom: 24, display: "flex", gap: 4 }}>
          <button className={`tab${activeTab === "transactions" ? " active" : ""}`} onClick={() => setActiveTab("transactions")}>Transactions</button>
          <button className={`tab${activeTab === "audit" ? " active" : ""}`} onClick={() => setActiveTab("audit")}>
            Audit Log <span style={{ background: "#eff6ff", color: "#2563eb", borderRadius: 20, padding: "1px 8px", fontSize: 11, marginLeft: 6 }}>{auditLog.length}</span>
          </button>
        </div>

        {activeTab === "transactions" && (
          <>
            <div style={{ display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap", alignItems: "center" }}>
              <div style={{ position: "relative", flex: 1, minWidth: 240 }}>
                <span style={{ position: "absolute", left: 11, top: "50%", transform: "translateY(-50%)", fontSize: 15, color: "#9ca3af" }}></span>
                <input className="input-base" style={{ paddingLeft: 34 }} value={searchText} onChange={e => setSearchText(e.target.value)} placeholder="Search by student, ID, description..." />
              </div>
              <button className="btn btn-primary text-white" style={{ width: "auto", minWidth: 140 }} onClick={e => searchActual()}>
               Search
              </button>
              <select className="input-base" style={{ width: "auto", minWidth: 150 }} value={filterStatus} onChange={e => setFilterStatus(e.target.value)}>
                <option value="all">All Statuses</option>
                <option value="Paid">Paid</option>
                <option value="voided">Voided</option>
                <option value="pending_void">Pending Void</option>
              </select>
               <select className="input-base" style={{ width: "auto", minWidth: 150 }} value={rowsPerPage} onChange={e => setRowsPerPage(e.target.value)}>
                <option value="50">Showing 50 rows</option>
                <option>100</option>
                <option>250</option>
                <option>500</option>
                <option>1000</option>
                <option>1500</option>
                <option>3000</option>
                <option>10000</option>
              </select>
              
              <div style={{ fontSize: 12, color: "#9ca3af", fontWeight: 600, whiteSpace: "nowrap" }}>{filtered.length} of {txns.length} records</div>
            </div>

            {txns.some(t => t.status === "pending_void") && (
              <div style={{ background: "#fffbeb", border: "1px solid #fde68a", borderRadius: 10, padding: "12px 18px", marginBottom: 16, display: "flex", alignItems: "center", gap: 10, fontSize: 13, fontWeight: 600, color: "#92400e" }}>
                <span>⚠️</span>
                <span>{txns.filter(t => t.status === "pending_void").length} transaction(s) are pending void approval.</span>
                <button className="btn btn-warning" style={{ marginLeft: "auto", padding: "5px 14px", fontSize: 12 }} onClick={() => setFilterStatus("pending_void")}>Review Now</button>
              </div>
            )}

            {selected && (
              <div id="modals" ref={detailRef} style={{ background: "#fff", border: "1.5px solid #bfdbfe", borderRadius: 14, padding: 24, marginTop: 12, display: "flex", gap: 32, flexWrap: "wrap" }}>
                <div style={{ flex: 1, minWidth: 260 }}>
                  <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 1, color: "#9ca3af", marginBottom: 14 }}>TRANSACTION DETAILS</div>
                  {[
                    ["Transaction ID", selected.reference],
                    ["Student", `${selected.student} (${selected.studentId})`],
                    ["Grade", selected.grade],
                    ["Description", selected.description],
                    ["Amount", `${selected.amount.toFixed(2)}`],
                    ["Date", selected.date],
                   
                    ["Payment Method", selected.paymentMethod],
                    ["Reference", selected.reference],
                    ["Created By", selected.createdBy],
                  ].map(([k, v]) => (
                    <div key={k} className="detail-row"><span className="detail-label">{k}</span><span className="detail-val">{v}</span></div>
                  ))}
                  {(selected.status === "voided" || selected.status === "pending_void") && (
                    <div style={{ marginTop: 14, padding: "12px 14px", background: "#fff1f2", border: "1px solid #fca5a5", borderRadius: 8 }}>
                      <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 1, color: "#dc2626", marginBottom: 8 }}>VOID INFORMATION</div>
                      {[
                        ["Category", selected.void_category],
                        ["Reason", selected.void_reason],
                        ["Voided By", selected.voided_by],
                        ["Voided At", selected.voided_at],
                        ["Approved By", selected.approved_by || "⏳ Pending"],
                      ].map(([k, v]) => (
                        <div key={k} className="detail-row"><span className="detail-label" style={{ color: "#f87171" }}>{k}</span><span className="detail-val" style={{ color: "#7f1d1d" }}>{v}</span></div>
                      ))}
                    </div>
                  )}
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: 10, minWidth: 180 }}>
                  <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 1, color: "#9ca3af", marginBottom: 4 }}>ACTIONS</div>
                  <button className="btn btn-danger" disabled={!canVoid} onClick={openVoid}>✕ Void Transaction</button>
                  {canApprove && <button className="btn btn-success" onClick={() => approveVoid(selected)}>✓ Approve Void</button>}
                  {canReverse && <button className="btn btn-warning" onClick={openReverse}>↩ Reverse Void</button>}
                  <button className="btn btn-ghost" onClick={() => setSelected(null)}>✕ Close Panel</button>
                  {!canVoid && selected.status !== "pending_void" && (
                    <div style={{ fontSize: 11, color: "#9ca3af", fontWeight: 500, marginTop: 4 }}>
                      {selected.status === "voided" ? "This transaction has been voided." : ""}
                    </div>
                  )}
                </div>
              </div>
            )}
            <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 14, overflow: "hidden", marginBottom: selected ? 0 : 0 }}>
              <div style={{ overflowX: "auto" }}>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr style={{ background: "#f8fafc", borderBottom: "2px solid #e5e7eb" }}>
                      {[["student", "Student"], ["reference", "TRANSACTION ID"], ["date", "Date"], ["type", "Payment Method"], ["amount", "Amount"], ["status", "Status"]].map(([f, label]) => (
                        <th key={f} style={{ padding: "12px 16px", textAlign: "left" }}>
                          <button className="th-btn" onClick={() => handleSort(f)}>{label}<SortIcon field={f} /></button>
                        </th>
                      ))}
                      <th style={{ padding: "12px 16px", textAlign: "left" }}><span className="th-btn">Action</span></th>
                    </tr>
                  </thead>
                  <tbody>
                    {filtered.length === 0 && (
                      <tr><td colSpan={8} style={{ padding: 40, textAlign: "center", color: "#9ca3af", fontSize: 14 }}>No transactions match your filters.</td></tr>
                    )}
                    {filtered.map((t, i) => (
                      <tr
                        key={t.id}
                        className={`row-hover${selected?.id === t.id ? " row-selected" : ""}`}
                        onClick={() => {setSelected(selected?.id === t.id ? null : t); setTimeout(() => {
    detailRef.current?.scrollIntoView({ 
      behavior: 'smooth', 
      block: 'start'
    });
  }, 50);}}
                        style={{ borderBottom: i < filtered.length - 1 ? "1px solid #f1f5f9" : "none", opacity: t.status === "voided" ? 0.65 : 1 }}
                      >
                        <td style={{ padding: "12px 16px" }}>
                          <div style={{ fontSize: 13, fontWeight: 700, color: "#111827" }}>{t.student}</div>
                          <div style={{ fontSize: 11, color: "#9ca3af", fontWeight: 500 }}>Admission : {t.studentId} · Class {t.grade}</div>
                        </td>
                        <td style={{ padding: "12px 16px", fontSize: 12, color: "#6b7280", fontWeight: 600, whiteSpace: "nowrap" }}>{t.id}</td>
                        <td style={{ padding: "12px 16px", fontSize: 13, color: "#374151", whiteSpace: "nowrap" }}>{t.date}</td>
                        <td style={{ padding: "12px 16px" }}>{t.paymentMethod}</td>
                      
                        <td style={{ padding: "12px 16px", fontSize: 14, fontWeight: 700, color: t.status === "voided" ? "#dc2626" : "#111827", whiteSpace: "nowrap" }}>
                          {t.status === "voided" && <span style={{ fontSize: 10, marginRight: 4 }}>VOID</span>}{t.amount.toFixed(2)}
                        </td>
                        <td style={{ padding: "12px 16px" }}><Badge style={STATUS_STYLES[t.status] || STATUS_STYLES.paid}>{STATUS_STYLES[t.status]?.label || t.status}</Badge></td>
                        <td style={{ padding: "12px 16px" }} onClick={e => e.stopPropagation()}>
                          {t.status === "pending_void" && (
                            <button className="btn btn-success" style={{ padding: "5px 12px", fontSize: 11 }} onClick={() => approveVoid(t)}>✓ Approve</button>
                          )}
                           {t.status === "Paid" && (
                            <button className="btn btn-secondary" style={{ padding: "5px 12px", fontSize: 11 }}      onClick={() => {setSelected(selected?.id === t.id ? null : t); setTimeout(() => {
    detailRef.current?.scrollIntoView({ 
      behavior: 'smooth', 
      block: 'start'
    });
  }, 50);}}>✓ Click to void</button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}

        {activeTab === "audit" && (
          <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 14, overflow: "hidden" }}>
            <div style={{ padding: "16px 20px", borderBottom: "1px solid #f1f5f9", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <div style={{ fontWeight: 700, fontSize: 15 }}>Void Audit Log</div>
              <span style={{ fontSize: 12, color: "#9ca3af", fontWeight: 600 }}>{auditLog.length} entries</span>
            </div>
            {auditLog.length === 0 ? (
              <div style={{ padding: 40, textAlign: "center", color: "#9ca3af", fontSize: 14 }}>No audit entries yet.</div>
            ) : (
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr style={{ background: "#f8fafc", borderBottom: "2px solid #e5e7eb" }}>
                    {["Transaction ID", "Action", "Performed By", "Date & Time", "Notes"].map(h => (
                      <th key={h} style={{ padding: "11px 16px", textAlign: "left", fontSize: 11, fontWeight: 700, color: "#6b7280", letterSpacing: "0.5px", textTransform: "uppercase" }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {auditLog.map((entry, i) => (
                    <tr key={i} style={{ borderBottom: i < auditLog.length - 1 ? "1px solid #f1f5f9" : "none" }}>
                      <td style={{ padding: "12px 16px", fontSize: 12, color: "#6b7280", fontWeight: 600 }}>{entry.id}</td>
                      <td style={{ padding: "12px 16px" }}>
                        <span style={{
                          fontSize: 11, fontWeight: 700, padding: "3px 9px", borderRadius: 20, letterSpacing: "0.5px",
                          background: entry.action.includes("REVERSE") ? "#eff6ff" : entry.action.includes("APPROVE") ? "#f0fdf4" : "#fff1f2",
                          color: entry.action.includes("REVERSE") ? "#2563eb" : entry.action.includes("APPROVE") ? "#15803d" : "#dc2626",
                          border: `1px solid ${entry.action.includes("REVERSE") ? "#bfdbfe" : entry.action.includes("APPROVE") ? "#86efac" : "#fca5a5"}`,
                        }}>{entry.action}</span>
                      </td>
                      <td style={{ padding: "12px 16px", fontSize: 13, color: "#374151", fontWeight: 500 }}>{entry.user}</td>
                      <td style={{ padding: "12px 16px", fontSize: 12, color: "#6b7280", whiteSpace: "nowrap" }}>{entry.time}</td>
                      <td style={{ padding: "12px 16px", fontSize: 13, color: "#374151", maxWidth: 300 }}>{entry.note}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )}
      </div>

      {modal === "void" && selected && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setModal(null)}>
          <div className="modal-box">
            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 22 }}>
              <div style={{ width: 40, height: 40, background: "#fee2e2", borderRadius: 10, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 20 }}>✕</div>
              <div>
                <div style={{ fontWeight: 700, fontSize: 18 }}>Void Transaction</div>
                <div style={{ fontSize: 12, color: "#6b7280", fontWeight: 500 }}>{selected.id} · {selected.student} · Ksh {selected.amount.toFixed(2)}</div>
              </div>
            </div>

            <div style={{ background: "#f8fafc", border: "1px solid #e5e7eb", borderRadius: 10, padding: "14px 16px", marginBottom: 20 }}>
              <div style={{ fontSize: 13, fontWeight: 600, color: "#374151" }}>{selected.description}</div>
              <div style={{ fontSize: 12, color: "#9ca3af", marginTop: 3 }}>{selected.paymentMethod} · {selected.date} · Ref: {selected.reference}</div>
            </div>

            <div style={{ marginBottom: 16 }}>
              <label style={{ display: "block", fontSize: 12, fontWeight: 700, color: "#374151", marginBottom: 6 }}>Void Category <span style={{ color: "#dc2626" }}>*</span></label>
              <select className="input-base" value={form.category} onChange={e => setForm(f => ({ ...f, category: e.target.value }))}>
                <option value="">Select a category...</option>
                {VOID_CATEGORIES.map(c => <option key={c} value={c}>{c}</option>)}
              </select>
            </div>

            <div style={{ marginBottom: 16 }}>
              <label style={{ display: "block", fontSize: 12, fontWeight: 700, color: "#374151", marginBottom: 6 }}>Void Reason <span style={{ color: "#dc2626" }}>*</span> <span style={{ color: "#9ca3af", fontWeight: 500 }}>(min 10 characters)</span></label>
              <textarea className="input-base" rows={3} value={form.reason} onChange={e => setForm(f => ({ ...f, reason: e.target.value }))} placeholder="Describe why this transaction is being voided..." style={{ resize: "vertical" }} />
              <div style={{ fontSize: 11, color: form.reason.length < 10 ? "#dc2626" : "#9ca3af", marginTop: 4, fontWeight: 500 }}>{form.reason.length}/10 minimum characters</div>
            </div>

          {/*  <div style={{ marginBottom: 16 }}>
              <label style={{ display: "block", fontSize: 12, fontWeight: 700, color: "#374151", marginBottom: 6 }}>Approving Officer <span style={{ color: "#9ca3af", fontWeight: 500 }}>(leave blank to submit for approval)</span></label>
              <input className="input-base" value={form.approver} onChange={e => setForm(f => ({ ...f, approver: e.target.value }))} placeholder="e.g. bursar@school.edu" />
            </div>*/}

            <div style={{ marginBottom: 20, display: "flex", alignItems: "center", gap: 10 }}>
              <input type="checkbox" id="notify" checked={form.notify} onChange={e => setForm(f => ({ ...f, notify: e.target.checked }))} style={{ width: 16, height: 16, accentColor: "#2563eb" }} />
              <label htmlFor="notify" style={{ fontSize: 13, color: "#374151", fontWeight: 500, cursor: "pointer" }}>Notify student/guardian by sms</label>
            </div>

            <div style={{ marginBottom: 24, background: "#fff1f2", border: "1px solid #fca5a5", borderRadius: 8, padding: "12px 14px" }}>
              <label style={{ display: "block", fontSize: 12, fontWeight: 700, color: "#dc2626", marginBottom: 6 }}>Type <strong>VOID</strong> to confirm this action</label>
              <input className="input-base" style={{ borderColor: "#fca5a5", background: "#fff" }} value={form.confirm} onChange={e => setForm(f => ({ ...f, confirm: e.target.value.toUpperCase() }))} placeholder="VOID" />
            </div>

            <div style={{ display: "flex", gap: 10 }}>
              <button className="btn btn-danger" style={{ flex: 1, fontSize: 14 }} disabled={!formValid} onClick={submitVoid}>
                {form.approver.trim() ? "✕ Confirm Void" : "Submit for Approval"}
              </button>
              <button className="btn btn-ghost" style={{ flex: 1, fontSize: 14 }} onClick={() => setModal(null)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {modal === "reverse" && selected && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setModal(null)}>
          <div className="modal-box">
            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 22 }}>
              <div style={{ width: 40, height: 40, background: "#eff6ff", borderRadius: 10, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 20 }}>↩</div>
              <div>
                <div style={{ fontWeight: 700, fontSize: 18 }}>Reverse Void</div>
                <div style={{ fontSize: 12, color: "#6b7280", fontWeight: 500 }}>{selected.id} · {selected.student}</div>
              </div>
            </div>
            <div style={{ fontSize: 13, color: "#374151", fontWeight: 500, marginBottom: 18, background: "#fffbeb", border: "1px solid #fde68a", borderRadius: 8, padding: "12px 14px" }}>
              ⚠️ Reversing a void will restore this transaction to <strong>Paid</strong> status. This action will be logged.
            </div>
            <div style={{ marginBottom: 20 }}>
              <label style={{ display: "block", fontSize: 12, fontWeight: 700, color: "#374151", marginBottom: 6 }}>Reason for Reversal <span style={{ color: "#dc2626" }}>*</span></label>
              <textarea className="input-base" rows={3} value={form.reason} onChange={e => setForm(f => ({ ...f, reason: e.target.value }))} placeholder="Explain why this void is being reversed..." style={{ resize: "vertical" }} />
            </div>
            <div style={{ display: "flex", gap: 10 }}>
              <button className="btn btn-primary" style={{ flex: 1, fontSize: 14 }} disabled={!form.reason.trim()} onClick={submitReverse}>↩ Confirm Reversal</button>
              <button className="btn btn-ghost" style={{ flex: 1, fontSize: 14 }} onClick={() => setModal(null)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {toast && (
        <div className="toast-wrap">
          <div style={{
            background: "#fff", border: `1px solid ${toast.type === "success" ? "#86efac" : toast.type === "info" ? "#bfdbfe" : "#fca5a5"}`,
            borderLeft: `4px solid ${toast.type === "success" ? "#16a34a" : toast.type === "info" ? "#2563eb" : "#dc2626"}`,
            borderRadius: 10, padding: "14px 20px", fontSize: 13, fontWeight: 600,
            color: toast.type === "success" ? "#15803d" : toast.type === "info" ? "#1d4ed8" : "#dc2626",
            boxShadow: "0 8px 32px rgba(0,0,0,0.12)", maxWidth: 360,
          }}>
            {toast.msg}
          </div>
        </div>
      )}
    </div>
  );
}